import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    grid_header: {
        marginTop: 10,
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: '70%',
            height: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            width: `20%`,
            height: '20%'
        },
        [theme.breakpoints.up('md')]: {
            width: `20%`,
            height: '20%'
        },
        [theme.breakpoints.up('lg')]: {
            width: `20%`,
            height: '20%'
        },
        [theme.breakpoints.up('xl')]: {
            width: `20%`,
            height: '20%'
        },
    }
}))

const Footer = props => {

    const classes = useStyles()

    return (
        <div>
            <Grid container className= {classes.grid_header} justify="center" alignItems="center" direction="row">
                {/* <img src={process.env.PUBLIC_URL + '/images/footer_caja.png'} alt="Logo" className= { classes.logo } /> */}
            </Grid> 
        </div>
    );
    
}

export default Footer;